import { render, staticRenderFns } from "./EditMyProgram.vue?vue&type=template&id=aba7a832&scoped=true&"
import script from "./EditMyProgram.vue?vue&type=script&lang=js&"
export * from "./EditMyProgram.vue?vue&type=script&lang=js&"
import style0 from "./EditMyProgram.vue?vue&type=style&index=0&id=aba7a832&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aba7a832",
  null
  
)

export default component.exports